<footer class="footer-section">
  <div class="footer-bg-image"></div>

  <div class="footer-content">
    <div class="footer-top">
      <!-- Brand column -->
      <div class="footer-col footer-brand-col">
        <div class="logo-container">
          <img src="assets/logos/logo.png" alt="e-Likita Logo" class="form-logo">
        </div>
        <p class="footer-tagline">
          Harnessing the power of AI to bridge healthcare delivery gaps by putting
          clinical decision support directly into the hands of frontline workers.
        </p>
        <div class="footer-social-icons">
          <a *ngFor="let social of socialLinks" [href]="social.href" [attr.aria-label]="social.label">
            <svg *ngIf="social.icon === 'facebook'" class="social-svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
            </svg>
            <svg *ngIf="social.icon === 'linkedin'" class="social-svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>
      </div>

      <!-- Link columns -->
      <div class="footer-col" *ngFor="let column of columns">
        <h3 class="footer-heading">{{ column.heading }}</h3>
        <ul class="footer-list">
          <li *ngFor="let link of column.links">
            <a *ngIf="link.routerLink" [routerLink]="link.routerLink">{{ link.label }}</a>
            <a *ngIf="!link.routerLink" [href]="link.href">{{ link.label }}</a>
          </li>
        </ul>
      </div>
    </div>

    <mat-divider class="footer-divider"></mat-divider>

    <div class="footer-bottom">
      <p class="footer-text">e-Likita Copyright {{ currentYear }} | All Rights Reserved</p>
    </div>
  </div>
</footer>
